export enum OrderFulfillmentStatus {
    Unfulfilled = 'unfulfilled',
    Partial = 'partial',
    Fulfilled = 'fulfilled',
}